<template>
  <section>
    <ul class="filters-list">
      <li>
        <router-link :to="{ name: 'AllCodingRules', query: $route.query }">
          Coding Rule Book
          <span class="active-icon"><img src="@/assets/images/caret-down-fill.svg" alt="" /></span>
        </router-link>
      </li>
      <li>
        <router-link :to="{ name: 'AllClaim', query: $route.query }">
          Claim Processing
          <span class="active-icon"><img src="@/assets/images/caret-down-fill.svg" alt="" /></span>
        </router-link>
      </li>
      <li>
        <router-link :to="{ name: 'AllARRules', query: $route.query }">
          AR Rule Book
          <span class="active-icon"><img src="@/assets/images/caret-down-fill.svg" alt="" /></span>
        </router-link>
      </li>
      <li>
        <router-link :to="{ name: 'PaymentRules', query: $route.query }">
          Payment Posting Rule Book
          <span class="active-icon"><img src="@/assets/images/caret-down-fill.svg" alt="" /></span>
        </router-link>
      </li>
      <li>
        <router-link :to="{ name: 'PatientRules', query: $route.query }">
          Patient Statement Rule Book
          <span class="active-icon"><img src="@/assets/images/caret-down-fill.svg" alt="" /></span>
        </router-link>
      </li>
    </ul>
  </section>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {}
};
</script>

<style scoped>
</style>
